import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Collapse, IconButton } from '@mui/material';
import { useState } from 'react';

interface CollapsibleSectionProps {
  title: React.ReactNode;
  defaultExpanded?: boolean;
  children: React.ReactNode;
  indent?: number;
}

export function CollapsibleSection({ title, defaultExpanded = false, children, indent = 0 }: CollapsibleSectionProps) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Box sx={{ ml: indent }}>
      <Box
        onClick={() => setExpanded(!expanded)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          '&:hover': { bgcolor: 'action.hover' },
          borderRadius: 0.5,
          py: 0.5,
        }}
      >
        <IconButton size="small" sx={{ p: 0, mr: 0.5 }}>
          {expanded ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
        </IconButton>
        {title}
      </Box>
      <Collapse in={expanded}>
        <Box sx={{ ml: 3 }}>{children}</Box>
      </Collapse>
    </Box>
  );
}
